// import { motion } from 'framer-motion'
// import { UserCircle } from 'lucide-react'
// import { type ComponentProps, type FC, memo } from 'react'
// import Markdown from 'react-markdown'
// import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
// import { dark } from 'react-syntax-highlighter/dist/esm/styles/prism'

// import { useGlobalChatStore } from '#app/routes/chat+/index.tsx'

// import { cn } from '#app/utils/misc.tsx'

// const components = {
// 	h1: ({ className, ...props }: ComponentProps<'h1'>) => (
// 		<h1
// 			className={cn(
// 				'mt-2 flex w-full items-center gap-1 text-3xl font-extrabold tracking-tight',
// 				className,
// 			)}
// 			{...props}
// 		/>
// 	),
// 	ol: ({ className, ...props }: ComponentProps<'ol'>) => (
// 		<ol
// 			className={cn(
// 				'-mb-3 -mt-3 list-decimal  py-0 pl-2 leading-none',
// 				className,
// 			)}
// 			{...props}
// 		/>
// 	),
// 	ul: ({ className, ...props }: ComponentProps<'ul'>) => (
// 		<ul
// 			className={cn('-mt-2 list-disc p-0 py-0 leading-none', className)}
// 			{...props}
// 		/>
// 	),
// 	li: ({ className, ...props }: ComponentProps<'li'>) => (
// 		<li
// 			className={cn('my-0 flex items-center py-0 leading-none', className)}
// 			{...props}
// 		>
// 			<span className="mr-2 list-inside list-disc">&#8226;</span>
// 			<span className="flex-1 leading-relaxed">{props.children}</span>
// 		</li>
// 	),
// 	code(props: { [x: string]: any; children: any; className: any; node: any }) {
// 		const { children, className, node, ...rest } = props
// 		const match = /language-(\w+)/.exec(className || '')
// 		return match ? (
// 			<SyntaxHighlighter
// 				{...rest}
// 				PreTag="div"
// 				children={String(children).replace(/\n$/, '')}
// 				language="js"
// 				style={dark}
// 			/>
// 		) : (
// 			<code {...rest} className={className}>
// 				{children}
// 			</code>
// 		)
// 	},
// }

// const MemoizedReactMarkdown: FC<any> = memo(
// 	Markdown,
// 	(prevProps, nextProps) =>
// 		prevProps.children === nextProps.children &&
// 		prevProps.className === nextProps.className,
// )

// const Message = (props: any) => {
// 	const { message } = props
// 	const isCurrentlyStreaming = useGlobalChatStore(
// 		state => state.isCurrentlyStreaming,
// 	)

// 	const { role, content: text } = message

// 	const isUser = role === 'user'

// 	return (
// 		<div className={`group w-full  text-gray-800`}>
// 			<div className="m-auto flex w-full gap-4 text-base md:max-w-2xl md:gap-6 lg:max-w-xl lg:px-0 xl:max-w-3xl">
// 				<div className="m-auto flex w-full flex-row  p-4 md:max-w-2xl md:py-6 lg:max-w-xl lg:px-0 xl:max-w-3xl">
// 					<div className="relative flex w-8 flex-col items-end">
// 						<div className="text-opacity-100r relative flex h-12 w-12 items-center justify-center rounded-sm  p-1 text-white">
// 							{isUser ? (
// 								<UserCircle className="-mt-4 h-6 w-6 text-primary-400" />
// 							) : (
// 								<div className="relative">
// 									<img
// 										src="/favicons/favicon.jpg"
// 										alt="Wiser logo"
// 										className="-mt-1 h-10 w-auto"
// 									/>
// 								</div>
// 							)}
// 						</div>
// 					</div>
// 					<div className="relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]">
// 						<div className="flex flex-grow flex-col gap-3">
// 							<div className="flex min-h-5 flex-col items-start gap-4 whitespace-pre-wrap break-words">
// 								<div className="markdown dark prose w-full break-words dark:prose-invert">
// 									<div>
// 										<p className="font-bold">{isUser ? 'You' : 'Wiser bot'}</p>
// 										<div className="flex flex-col">
// 											<div className="block">
// 												<MemoizedReactMarkdown components={components}>
// 													{text}
// 												</MemoizedReactMarkdown>
// 											</div>
// 											{isCurrentlyStreaming && props.isLastMessage && (
// 												<FramerTextBall />
// 											)}
// 										</div>
// 									</div>
// 								</div>
// 							</div>
// 						</div>
// 					</div>
// 				</div>
// 			</div>
// 		</div>
// 	)
// }

// export default Message

// export function FramerTextBall() {
// 	return (
// 		<div
// 			style={{
// 				display: 'inline-flex',
// 				minWidth: '1rem',
// 				minHeight: '1rem',
// 			}}
// 		>
// 			<motion.div
// 				animate={{
// 					scale: [1, 1.3, 1],
// 				}}
// 				transition={{
// 					duration: 1.4,
// 					ease: 'easeInOut',
// 					repeat: Infinity,
// 					repeatType: 'loop',
// 					repeatDelay: 0,
// 				}}
// 				style={{
// 					borderRadius: '50%',
// 					backgroundColor: '#55637c',
// 					width: '1rem',
// 					marginTop: '0.5rem',
// 					marginLeft: '0.2rem',
// 					paddingRight: '1rem',
// 					height: '1rem',
// 					display: 'inline-block',
// 				}}
// 			/>
// 		</div>
// 	)
// }

import { motion } from 'framer-motion'
import { UserCircle } from 'lucide-react'
import { type ComponentProps, type FC, memo } from 'react'
import Markdown from 'react-markdown'
import { useGlobalChatStore } from '#app/routes/chat+/index.tsx'

import { cn } from '#app/utils/misc.tsx'

const components = {
	h1: ({ className, ...props }: ComponentProps<'h1'>) => (
		<h1
			className={cn(
				'mt-2 flex w-full items-center gap-1 text-3xl font-extrabold tracking-tight',
				className,
			)}
			{...props}
		/>
	),
	ol: ({ className, ...props }: ComponentProps<'ol'>) => (
		<ol
			className={cn(
				'-mb-3 -mt-3 list-decimal  py-0 pl-2 leading-none',
				className,
			)}
			{...props}
		/>
	),
	ul: ({ className, ...props }: ComponentProps<'ul'>) => (
		<ul
			className={cn('-mt-2 list-disc p-0 py-0 leading-none', className)}
			{...props}
		/>
	),
	li: ({ className, ...props }: ComponentProps<'li'>) => (
		<li
			className={cn('my-0 flex items-center py-0 leading-none', className)}
			{...props}
		>
			<span className="mr-2 list-inside list-disc">&#8226;</span>
			<span className="flex-1 leading-relaxed">{props.children}</span>
		</li>
	),
}

const MemoizedReactMarkdown: FC<any> = memo(
	Markdown,
	(prevProps, nextProps) =>
		prevProps.children === nextProps.children &&
		prevProps.className === nextProps.className,
)

const Message = (props: any) => {
	const { message } = props
	const isCurrentlyStreaming = useGlobalChatStore(
		state => state.isCurrentlyStreaming,
	)

	const { role, content: text } = message

	const isUser = role === 'user'

	return (
		<div className={`group w-full  text-gray-800`}>
			<div className="m-auto flex w-full gap-4 text-base md:max-w-2xl md:gap-6 lg:max-w-xl lg:px-0 xl:max-w-3xl">
				<div className="m-auto flex w-full flex-row  p-4 md:max-w-2xl md:py-6 lg:max-w-xl lg:px-0 xl:max-w-3xl">
					<div className="relative flex w-8 flex-col items-end">
						<div className="text-opacity-100r relative flex h-12 w-12 items-center justify-center rounded-sm  p-1 text-white">
							{isUser ? (
								<UserCircle className="-mt-4 h-6 w-6 text-primary-400" />
							) : (
								<div className="relative">
									<img
										src="/favicons/favicon.jpg"
										alt="Wiser logo"
										className="-mt-1 h-10 w-auto"
									/>
								</div>
							)}
						</div>
					</div>
					<div className="relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]">
						<div className="flex flex-grow flex-col gap-3">
							<div className="flex min-h-5 flex-col items-start gap-4 whitespace-pre-wrap break-words">
								<div className="markdown dark prose w-full break-words dark:prose-invert">
									<div>
										<p className="font-bold">{isUser ? 'You' : 'Wiser bot'}</p>
										<div className="flex flex-col">
											<div className="block">
												<MemoizedReactMarkdown components={components}>
													{text}
												</MemoizedReactMarkdown>
											</div>
											{isCurrentlyStreaming && props.isLastMessage && (
												<FramerTextBall />
											)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Message

export function FramerTextBall() {
	return (
		<div
			style={{
				display: 'inline-flex',
				minWidth: '1rem',
				minHeight: '1rem',
			}}
		>
			<motion.div
				animate={{
					scale: [1, 1.3, 1],
				}}
				transition={{
					duration: 1.4,
					ease: 'easeInOut',
					repeat: Infinity,
					repeatType: 'loop',
					repeatDelay: 0,
				}}
				style={{
					borderRadius: '50%',
					backgroundColor: '#55637c',
					width: '1rem',
					marginTop: '0.5rem',
					marginLeft: '0.2rem',
					paddingRight: '1rem',
					height: '1rem',
					display: 'inline-block',
				}}
			/>
		</div>
	)
}
